import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { Button, Icons } from 'sarsaparilla';
import { addChange, clearChange, getRef } from '../../actions/changes';
import { EventProps } from '../../props/event';
import { InputPicker, Types } from './InputPicker';

import pageStyles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';

const propTypes = {
  value: EventProps,
  eventType: PropTypes.string,
  onRemove: PropTypes.func.isRequired,
  getRef: PropTypes.func.isRequired,
  addChange: PropTypes.func.isRequired,
  clearChange: PropTypes.func.isRequired
};

export class EventEdit extends PureComponent {
  static inputs = [
    {
      type: Types.TEXT,
      label: 'Event Name',
      required: true,
      field: 'name'
    },
    {
      type: Types.TEXT,
      label: 'Event Email',
      field: 'email'
    },
    {
      type: Types.TEXT,
      label: 'Event URL Address',
      field: 'url'
    },
    {
      type: Types.TEXT,
      label: 'Event URL Text',
      field: 'urlText'
    },
    {
      type: Types.DATE,
      label: 'Event Start Date',
      field: 'startDate'
    },
    {
      type: Types.DATE,
      label: 'Event End Date',
      field: 'endDate'
    },
    {
      type: Types.TEXT,
      label: 'Event Age Group',
      field: 'ageGroup'
    },
    {
      type: Types.CHECKBOX,
      label: 'Registration Required',
      field: 'registrationRequired'
    },
    {
      type: Types.TEXTBOX,
      label: 'Event Description',
      field: 'description'
    },
    {
      type: Types.TEXTBOX,
      label: 'Event Type Description',
      field: 'typeDescription'
    },
    {
      type: Types.TEXTBOX,
      label: 'Event Scope Description',
      field: 'scopeDescription'
    },
    {
      type: Types.TEXTBOX,
      label: 'Event Frequency Rate Description',
      field: 'frequencyRateDescription'
    },
    {
      type: Types.TEXTBOX,
      label: 'Event Fee Description',
      field: 'feeDescription'
    },
    {
      type: Types.BLANK,
      field: 'blank1'
    },
    {
      type: Types.TEXT,
      label: 'Sponsor Name',
      field: 'sponsorName'
    },
    {
      type: Types.TEXT,
      label: 'Sponsor Class Type',
      field: 'sponsorClassType'
    },
    {
      type: Types.TEXT,
      label: 'Sponsor Phone',
      field: 'sponsorPhone'
    },
    {
      type: Types.TEXT,
      label: 'Sponsor Email',
      field: 'sponsorEmail'
    },
    {
      type: Types.TEXT,
      label: 'Sponsor URL Address',
      field: 'sponsorUrl'
    },
    {
      type: Types.TEXT,
      label: 'Sponsor URL Text',
      field: 'sponsorUrlText'
    }
  ];

  constructor(props) {
    super(props);

    this.state = {
      record: this.props.value,
      ref: this.props.getRef(
        this.props.eventType,
        { id: this.props.value.id },
        0,
        ['name'].reduce((m, f) => Object.assign(m, { [f]: props.value[f] }), {})
      )
    };

    this.handleChange = this.handleChange.bind(this);
    this.doRemove = this.doRemove.bind(this);

    if (!props.value.id) {
      this.props.addChange(this.state.ref, { registrationRequired: false });
      this.props.addChange(this.state.ref, { startDate: moment().format('YYYY-MM-DD') });
      this.props.addChange(this.state.ref, { endDate: moment().format('YYYY-MM-DD') });
    }
  }

  handleChange(event) {
    const { dataset: { field }, value } = event.target;
    const change = { [field]: value };

    this.setState((prevState) => ({
      ...prevState,
      record: { ...prevState.record, ...change }
    }), () => this.props.addChange(this.state.ref, change));
  }

  doRemove() {
    if (this.props.value.id) {
      this.props.addChange(this.state.ref, { _delete: true });
    }
    else {
      this.props.clearChange(this.state.ref);
    }
    this.props.onRemove(this.props.value._key);
  }

  render() {
    const { record, ref } = this.state;

    return (
      <div className={pageStyles['section-box']}>
        <Button
          appearance="subtle-danger"
          onClick={this.doRemove}
          className={pageStyles['delete-button']}
          iconBeforeElement={<Icons.IconClose />} />
        {EventEdit.inputs.map((input) => InputPicker(input, ref, record, this.handleChange))}
      </div>
    );
  }
}

EventEdit.propTypes = propTypes;

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getRef,
  addChange,
  clearChange
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EventEdit);
